import { useCockpit } from "../../lib/state";

const ROWS: Array<[string[], string]> = [
  [["⌘", "K"], "Command palette (projects · tasks · services · actions)"],
  [["⌘", "P"], "Quick project jump"],
  [["⌘", "N"], "New task on selected project"],
  [["⌘", "E"], "Focus the note editor"],
  [["⌘", "S"], "Save note (in editor)"],
  [["j"], "Next project"],
  [["k"], "Previous project"],
  [["g", "r"], "Jump to Row1"],
  [["g", "t"], "Jump to Tagral"],
  [["g", "s"], "Jump to Services"],
  [["?"], "Show this help"],
  [["Esc"], "Close drawer / palette / help"],
];

export default function HelpOverlay() {
  const open = useCockpit((s) => s.helpOpen);
  const setHelpOpen = useCockpit((s) => s.setHelpOpen);
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        background:
          "radial-gradient(ellipse at center, rgba(255,31,165,0.18), rgba(74,19,66,0.45))",
        backdropFilter: "blur(8px)",
      }}
      onClick={() => setHelpOpen(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="aero-glass aero-glass-strong w-full max-w-md p-6"
        style={{ borderRadius: 28 }}
      >
        <span
          className="font-eyebrow"
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "var(--hot-pink)",
          }}
        >
          ✦ Keyboard
        </span>
        <h2
          className="mt-1 mb-4 text-2xl"
          style={{
            fontFamily: "Fraunces, serif",
            fontStyle: "italic",
            fontWeight: 700,
            letterSpacing: "-0.01em",
          }}
        >
          <span className="holo-text">Cockpit shortcuts</span>
        </h2>
        <ul className="flex flex-col gap-2">
          {ROWS.map(([keys, label], i) => (
            <li key={i} className="flex items-center gap-3">
              <span className="flex shrink-0 items-center gap-1" style={{ width: 90 }}>
                {keys.map((k, j) => (
                  <span key={j} className="kbd">
                    {k}
                  </span>
                ))}
              </span>
              <span
                className="text-xs"
                style={{
                  fontFamily: "Fraunces, serif",
                  fontStyle: "italic",
                  fontSize: 13,
                  color: "var(--ink)",
                }}
              >
                {label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
